<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12" md="6" lg="3">
        <b-select v-model="selectedCube" :options="cubes"></b-select>
      </b-col>
    </b-row>
    <b-tabs content-class="mt-3">
      <b-tab title="Measure Group Configs" lazy>
        <measure-group-configs :cubeId="selectedCube" />
      </b-tab>
      <b-tab title="Measure Configs" lazy>
        <measure-configs :cubeId="selectedCube" />
      </b-tab>
      <b-tab title="Level Configs" lazy>
        <level-configs :cubeId="selectedCube" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import _ from 'lodash';
import LevelConfigs from '@/views/admin/LevelConfigs';
import MeasureConfigs from '@/views/admin/MeasureConfigs';
import MeasureGroupConfigs from '@/views/admin/MeasureGroupConfigs';
import adminServices from '../../services/adminServices';

export default {
  name: 'SmartGrabberManagement',
  components: { MeasureGroupConfigs, MeasureConfigs, LevelConfigs },
  mounted() {
    this.getCubes();
  },
  data() {
    return {
      cubes: [],
      selectedCube: null,
    };
  },
  methods: {
    getCubes() {
      adminServices.getCubes().then(resp => {
        this.cubes = _.sortBy(resp.data, ['value']);
        this.selectedCube = this.cubes[0].value;
      });
    },
  },
};
</script>

<style scoped></style>